<template>
  <div class="message">
    <textarea class="textarea main-message disp-scroll"
      :value="scenarioEdit.mainmessage"
      placeholder="例：お名前を入力してください"
      @input="updateMainMessage($event.target.value)"
      :disabled="scenarioEdit.is_confirm">
    </textarea>
    <p class="comment">
      (※)
      未入力の場合、「応募フォームはこちらになります！ご記入のほど、よろしくお願いいたします！」と表示されます。
    </p>
    <div style="margin-top: 25px;">
      <p style="text-align: left">
        <b>メール無効　</b>
        <span style="color: #666; font-size: 12px">
          ONにしますと、応募完了メールを送付しません。
        </span>
      </p>
    </div>
    <div style="justify-content: center">
      <b-switch
        v-model="applyParameter.disable_email"
        :disabled="scenarioEdit.is_confirm">
        {{applyParameter.disable_email ? "送付しない" : "送付する"}}
      </b-switch>
    </div>
    <div style="margin-top: 25px;">
      <p style="text-align: left">
        <b>生年月日の初期値</b>
      </p>
      <section class="section-3">
        <b-datepicker
          locale="ja-JP"
          v-model="defaultBirth"
          @input="changedefaultBirth(defaultBirth)"
          :focused-date="defaultBirth"
          :mobile-native="false"
          placeholder="生年月日の初期値を設定"
          :open-on-focus="true"
          icon="calendar-today"
        >
        </b-datepicker>  
      </section>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    scenarioEdit: {
      type: Object,
      required: true,
    },
    applyParameter: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      defaultBirth: null
    }
  },
  mounted() {
    if (!this.applyParameter['default_birth']) {
      this.defaultBirth = new Date()
    } else {
      this.defaultBirth = new Date(this.applyParameter['default_birth'])
    }
  },
  methods: {
    updateMainMessage(value) {
      this.$emit('update-mainmessage', value)
    },
    changedefaultBirth (defaultBirth) {
      this.applyParameter['default_birth'] = defaultBirth
    }
  },
}
</script>

<style scoped lang="scss">
.message {
  background: #ffffff;
  max-height: calc(100vh - 300px);
  overflow: auto;
  padding: 8px;
  .comment {
    text-align: left;
    color: grey;
    font-size: 13px;
  }
}
.message::-webkit-scrollbar {
  width: 6px;
  height: 0px;
  visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/chatbot/scenarioEdit/ScenarioEditApply.vue